"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDefaultRouter = createDefaultRouter;
exports["default"] = createRouter;
var _regenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/regenerator"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _utils = require("./utils");
var _excluded = ["action"],
  _excluded2 = ["wapp"];
function createDefaultRouter() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp,
    routes = p.routes;
  function match() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var path = p.path;
    var routes = router.routes;
    var route = null;
    var params = {};
    routes.forEach(function (r) {
      if (path && r.path) {
        var _match = false;
        var thisParams = {};
        try {
          var rPath = r.path.slice(-1) === "/" ? r.path.slice(0, -1) : r.path;
          var sPath = path.slice(-1) === "/" ? path.slice(0, -1) : path;
          var rpa = rPath.split("/");
          var pa = sPath.split("/");
          var allPartIsMatch = true;
          var wasAllowChar = false;
          rpa.forEach(function (rpas, i) {
            var param = rpas && rpas.slice(0, 1) === ":";
            var allow = rpas === "*";
            if (allow) {
              wasAllowChar = true;
            }
            if (typeof pa[i] == "string") {
              if (pa[i] === rpas || param || allow) {} else {
                allPartIsMatch = false;
              }
              if (param) {
                thisParams[rpas.slice(1)] = pa[i];
              }
            }
          });
          if (pa.length > rpa.length && !wasAllowChar) {
            allPartIsMatch = false;
          }
          if (allPartIsMatch) {
            _match = true;
          }
        } catch (e) {}
        if (_match && !route) {
          params = thisParams;
          route = r;
        }
      }
    });
    return route ? (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, route), {}, {
      params: params
    }) : route;
  }
  function getRoute() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var path = p.path;
    var r = {
      requestPath: null,
      status: null
    };
    if (path) {
      var routeByPath = router.match({
        path: path
      });
      if (routeByPath) {
        r = (0, _objectSpread2["default"])({
          requestPath: path,
          status: 200
        }, routeByPath);
      }
    }
    if (!r.status) {
      var notFoundPath = router.match({
        path: "/404"
      });
      var homePath = router.match({
        path: "/home"
      });
      homePath = homePath || router.match({
        path: "/"
      });
      var firstPath = router.routes[0] && router.routes[0].path ? router.match({
        path: router.routes[0].path
      }) : null;
      var foundPath = notFoundPath ? notFoundPath : homePath ? homePath : firstPath ? firstPath : (0, _objectSpread2["default"])({}, r);
      if (foundPath) {
        r = (0, _objectSpread2["default"])({
          requestPath: path,
          status: 404
        }, foundPath);
      }
    }
    return r;
  }
  function defaultResolve() {
    return _defaultResolve.apply(this, arguments);
  }
  function _defaultResolve() {
    _defaultResolve = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee() {
      var p,
        path,
        req,
        res,
        _router$getRoute,
        _router$getRoute$acti,
        action,
        rest,
        r,
        _args = arguments;
      return (0, _regenerator2["default"])().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            p = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            path = p.path, req = p.req, res = p.res;
            _router$getRoute = router.getRoute({
              path: path
            }), _router$getRoute$acti = _router$getRoute.action, action = _router$getRoute$acti === void 0 ? defaultAction : _router$getRoute$acti, rest = (0, _objectWithoutProperties2["default"])(_router$getRoute, _excluded);
            _context.n = 1;
            return action((0, _objectSpread2["default"])({
              wapp: wapp,
              req: req,
              res: res
            }, rest));
          case 1:
            r = _context.v;
            _context.n = 2;
            return router.action((0, _objectSpread2["default"])({
              wapp: wapp,
              req: req,
              res: res
            }, r));
          case 2:
            r = _context.v;
            return _context.a(2, r);
        }
      }, _callee);
    }));
    return _defaultResolve.apply(this, arguments);
  }
  function defaultAction() {
    return _defaultAction.apply(this, arguments);
  }
  function _defaultAction() {
    _defaultAction = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee2() {
      var p,
        wapp,
        rest,
        _args2 = arguments;
      return (0, _regenerator2["default"])().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            p = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
            wapp = p.wapp, rest = (0, _objectWithoutProperties2["default"])(p, _excluded2);
            return _context2.a(2, (0, _objectSpread2["default"])({}, rest));
        }
      }, _callee2);
    }));
    return _defaultAction.apply(this, arguments);
  }
  function defaultAdd(obj) {
    if (typeof obj === "object" && obj.length) {
      obj.forEach(function (route) {
        if (typeof route == "object" && route.path) {
          var foundRoute = false;
          router.routes.forEach(function (aRoute) {
            if (aRoute.path === route.path) {
              foundRoute = true;
            }
          });
          if (!foundRoute) {
            router.routes.push(route);
          }
        }
      });
    } else {
      if (typeof obj == "object" && obj.path) {
        var foundRoute = false;
        router.routes.forEach(function (aRoute) {
          if (aRoute.path === obj.path) {
            foundRoute = true;
          }
        });
        if (!foundRoute) {
          router.routes.push(obj);
        }
      }
    }
  }
  function defaultReplace(obj) {
    if (typeof obj === "object" && obj.length) {
      obj.forEach(function (objRoute) {
        if (typeof objRoute == "object" && objRoute.path) {
          var replaced = false;
          router.routes.forEach(function (route, i) {
            if (route.path === objRoute.path) {
              router.routes[i] = objRoute;
              replaced = true;
            }
          });
          if (!replaced) {
            router.routes.push(objRoute);
          }
        }
      });
    } else {
      if (typeof obj == "object" && obj.path) {
        var replaced = false;
        router.routes.forEach(function (route, i) {
          if (route.path === obj.path) {
            router.routes[i] = obj;
            replaced = true;
          }
        });
        if (!replaced) {
          router.routes.push(obj);
        }
      }
    }
  }
  var defaultRoutes = routes || [{
    path: "/",
    contentName: "log"
  }];
  var router = Object.create(Object.prototype, {
    wapp: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      enumerable: false,
      value: wapp
    }),
    match: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: match
    }),
    getRoute: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: getRoute
    }),
    resolve: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultResolve
    }),
    action: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultAction
    }),
    routes: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      value: defaultRoutes
    }),
    add: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultAdd
    }),
    replace: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultReplace
    })
  });
  return router;
}
function createRouter() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp,
    _p$routeManager = p.routeManager,
    routeManager = _p$routeManager === void 0 ? createDefaultRouter(p) : _p$routeManager;
  function defaultHandle(_x, _x2, _x3) {
    return _defaultHandle.apply(this, arguments);
  }
  function _defaultHandle() {
    _defaultHandle = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee3(req, res, next) {
      var wappResponse, wappRequest, routerRes, path, route;
      return (0, _regenerator2["default"])().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            wappResponse = res.wappResponse;
            wappRequest = req.wappRequest;
            routerRes = routerMiddleware.routeManager.resolve;
            path = wappRequest.path || wappRequest.url;
            _context3.n = 1;
            return routerRes({
              path: path,
              req: req,
              res: res
            });
          case 1:
            route = _context3.v;
            wappResponse.statusCode = wappResponse.statusCode === 200 || !wappResponse.statusCode ? route.status : wappResponse.statusCode;
            wappResponse.route = route;
            if (wappResponse.statusCode) {
              wappResponse.status(wappResponse.statusCode);
            }
            if (!(wappRequest.path === "/500" && wappResponse.statusCode === 404)) {
              _context3.n = 2;
              break;
            }
            //test an error
            wappResponse.route.contentName = "";
            throw new Error("Internal Server Error (Test)");
          case 2:
            return _context3.a(2, next());
        }
      }, _callee3);
    }));
    return _defaultHandle.apply(this, arguments);
  }
  function defaultAdd(p) {
    return routerMiddleware.routeManager.add(p);
  }
  function defaultReplace(p) {
    return routerMiddleware.routeManager.replace(p);
  }
  var routerMiddlewareProperties = Object.create(Object.prototype, {
    handle: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultHandle
    }),
    routeManager: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: routeManager
    }),
    add: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultAdd
    }),
    replace: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultReplace
    })
  });
  function routerMiddleware(_x4, _x5, _x6) {
    return _routerMiddleware.apply(this, arguments);
  }
  function _routerMiddleware() {
    _routerMiddleware = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee4(req, res, next) {
      return (0, _regenerator2["default"])().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            if (!(typeof routerMiddleware.handle === "function")) {
              _context4.n = 2;
              break;
            }
            _context4.n = 1;
            return routerMiddleware.handle(req, res, next);
          case 1:
            return _context4.a(2, _context4.v);
          case 2:
            return _context4.a(2, routerMiddleware);
        }
      }, _callee4);
    }));
    return _routerMiddleware.apply(this, arguments);
  }
  (0, _utils.mergeProperties)(routerMiddleware, routerMiddlewareProperties);
  Object.defineProperty(routerMiddleware, "wapp", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
    writable: false,
    enumerable: false,
    value: wapp
  }));
  Object.defineProperty(wapp, "router", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
    writable: false,
    value: routerMiddleware
  }));
  return routerMiddleware;
}